/**
 * Progressable
 * Generic class for generating progress-like overlays (overlay with a spinner)
 * @package Foundation/Progressable
 */
export class Progressable {
    /**
     * Class initialization
     * @param  {Object} args - override of class settings
     */
    constructor (...args) {
        this._refs = {
            spinner: null,
            backdrop: null
        };
        this.settings = {...args, ...this._settings};
    }

    /**
     * Show overlay + spinner
     */
    show () {
        // Backdrop
        const oBackdrop = document.createElement('div');
        if(this._settings.elements.backdrop.classlist !== '') {
            oBackdrop.setAttribute('class', this._settings.elements.backdrop.classlist);    
        }

        if(this._settings.elements.backdrop.id !== '') {
            oBackdrop.setAttribute('id', this._settings.elements.backdrop.id);
        }

        // Spinner
        const oSpinner = document.createElement('div');
        if(this._settings.elements.icon.id != '') {
            oSpinner.setAttribute('id', this._settings.elements.icon.id);
        }
        oSpinner.innerHTML = `<i class="${this._settings.elements.icon.classlist}" aria-hidden='true'></i>`;

        // Inject backdrop and spinner
        const oBody = document.getElementsByTagName('body')[0];

        // Save reference 
        this._refs.backdrop = oBackdrop;
        this._refs.spinner = oSpinner;

        // Append to body
        oBody.appendChild(oBackdrop);
        oBody.appendChild(oSpinner);
    }

    /**
     * Remove overlay + spinner and reset references
     */
    _remove () {
        if(this._refs.spinner == null || this._refs.backdrop == null) {
            return;
        }

        this._refs.spinner.parentNode.removeChild(this._refs.spinner);
        this._refs.backdrop.parentNode.removeChild(this._refs.backdrop);

        // Reset
        this._refs.spinner = null; 
        this._refs.backdrop = null;
    }

    /**
     * Generic settings for class
     */
    get _settings () {
        return {
            'elements': {
                'backdrop': {
                    'classlist': 'fade in',
                    'id': 'progress-backdrop'
                },
                'icon': {
                    'classlist': 'eva eva-loader-outline',
                    'id': 'progress',
                }
            }
        }
    }
}